import React from 'react'
import pagination from '../../utils/pagination'

const arrowClass = (disabled) =>
  `w-8 h-8 rounded-lg border border-line bg-white text-muted flex items-center justify-center text-sm transition-colors ${
    disabled
      ? 'opacity-40 cursor-not-allowed'
      : 'hover:bg-subtle hover:text-ink cursor-pointer'
  }`

const Pagination = ({ totalPage, currentPage, onChange }) => {
  return (
    <div className="flex items-center gap-1.5">
      <button
        className={arrowClass(currentPage <= 1)}
        disabled={currentPage <= 1}
        onClick={() => currentPage > 1 && onChange(currentPage - 1)}
      >
        &lt;
      </button>
      {pagination(totalPage, currentPage, totalPage > 7 ? 7 : totalPage).map(
        ({ key, number }) => {
          if (number === '...') {
            return (
              <span
                key={key}
                className="w-8 h-8 flex items-center justify-center text-sm text-muted"
              >
                ...
              </span>
            )
          }
          const isActive = number + 1 === currentPage
          return (
            <button
              key={key}
              className={`w-8 h-8 rounded-lg border text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-ink border-ink text-white'
                  : 'bg-white border-line text-ink hover:bg-subtle'
              }`}
              onClick={() => onChange(number + 1)}
            >
              {number + 1}
            </button>
          )
        },
      )}
      <button
        className={arrowClass(currentPage >= totalPage)}
        disabled={currentPage >= totalPage}
        onClick={() => currentPage < totalPage && onChange(currentPage + 1)}
      >
        &gt;
      </button>
    </div>
  )
}

export default Pagination
